const firebaseConfig = {
    apiKey: "AIzaSyC3lZqTonT9VInK_5C8mG3PiH60X4jE1cQ",
    authDomain: "true-tour-mentor-6bffb.firebaseapp.com",
    projectId: "true-tour-mentor-6bffb",
    storageBucket: "true-tour-mentor-6bffb.appspot.com",
    messagingSenderId: "2422318380",
    appId: "1:2422318380:web:ddb1e87836979a2d7f7889"
  };
export default firebaseConfig;  